<template>
<b-navbar class = "bg-company-red" toggleable="md"  >
<b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

<b-collapse is-nav id="nav_collapse">
<b-navbar-nav>
    <b-nav-item to="/main">Главная</b-nav-item>
    
    <!-- <b-nav-item href="/tarifs" disabled>about</b-nav-item> -->
    <b-nav-item to="/tarifs">Тарифы</b-nav-item>
    <b-nav-item to="/news">Новости</b-nav-item>
    <b-nav-item to="/about">Об услуге</b-nav-item>
    <b-nav-item  v-if="visible" to="/vats">Виртуальная АТС</b-nav-item>
</b-navbar-nav>

    <!-- Right aligned nav items -->
    <b-navbar-nav class="ml-auto">

      <!-- <b-nav-form>
        <b-form-input size="sm" class="mr-sm-2" type="text" placeholder="Search"/>
        <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
      </b-nav-form> -->

      <!-- <b-nav-item-dropdown text="Lang" right>
        <b-dropdown-item href="#">EN</b-dropdown-item>
        <b-dropdown-item href="#">ES</b-dropdown-item>
        <b-dropdown-item href="#">RU</b-dropdown-item>
        <b-dropdown-item href="#">FA</b-dropdown-item>
      </b-nav-item-dropdown> -->

      <!-- <b-nav-item-dropdown right>

        <template slot="button-content">
          <em>User</em>
        </template>
        <b-dropdown-item href="#">Profile</b-dropdown-item>
        <b-dropdown-item href="#">Signout</b-dropdown-item>
      </b-nav-item-dropdown> -->
    </b-navbar-nav>
    <!-- <b-navbar-nav right>
        <b-nav-item to="/login">Войти</b-nav-item>
    </b-navbar-nav> -->
  </b-collapse>
</b-navbar>

</template>
<script>
export default {
  name: "navbar",
  data() {
    return {
      visible: false
    };
  },
  watch: {}
};
</script>

<style scoped>
.bar_color {
  color: orangered;
}
.bg-company-red {
  background-color: #ffa021;
}
</style>



// WEBPACK FOOTER //
// src/Navbar.vue